import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Briefcase,
  Code,
  Layers,
  Users,
  DollarSign,
  BarChart3,
  Mail,
  FileText,
  ChevronRight,
} from "lucide-react";

const sidebarItems = [
  { path: "/admin", label: "Dashboard", icon: BarChart3 },
  { path: "/admin/roles", label: "Roles", icon: Briefcase },
  { path: "/admin/skills", label: "Skills", icon: Code },
  { path: "/admin/categories", label: "Categories", icon: Layers },
  { path: "/admin/resources", label: "Resources", icon: Users },
  { path: "/admin/rates", label: "Rates", icon: DollarSign },
  { path: "/admin/contacts", label: "Contacts", icon: Mail },
  { path: "/admin/inquiries", label: "Inquiries", icon: FileText },
];

export const Sidebar = () => {
  const location = useLocation();

  return (
    <aside className="hidden lg:flex flex-col w-64 bg-gradient-to-b from-gray-900 to-gray-800 text-white">
      <div className="p-6 border-b border-gray-700">
        <h2 className="text-lg font-bold">Admin Panel</h2>
      </div>

      <nav className="flex-1 overflow-y-auto py-4">
        {sidebarItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-6 py-3 transition-colors ${
                isActive
                  ? "bg-blue-600 text-white border-l-4 border-blue-400"
                  : "text-gray-300 hover:bg-gray-700"
              }`}
            >
              <Icon size={20} />
              <span className="flex-1">{item.label}</span>
              {isActive && <ChevronRight size={16} />}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};
